import React from 'react';
import { CheckIcon } from 'lucide-react';
interface ChoiceCardProps {
  title: string;
  summary?: string;
  note?: string;
  selected?: boolean;
  onClick: () => void;
  icon?: React.ReactNode;
}
export function ChoiceCard({
  title,
  summary,
  note,
  selected = false,
  onClick,
  icon
}: ChoiceCardProps) {
  return <button type="button" onClick={onClick} aria-pressed={selected} className={`flex h-full w-full flex-col items-start gap-1 rounded-3xl border p-5 text-left transition-colors duration-150 ease-out hc-strong ${selected ? 'border-teal bg-teal text-cream' : 'border-line bg-paper text-ink hover:bg-sand'}`} data-id="element-511" data-mp="p9h0abwm3pn4">
      <span className="flex w-full items-start justify-between gap-3" data-id="element-512" data-mp="141hjxregr0of">
        <span className="flex items-center gap-2 font-display text-xl font-semibold" data-id="element-513" data-mp="17z5jx8v0jjn6">
          {icon}
          {title}
        </span>
        {selected && <span className="flex shrink-0 items-center gap-1 text-sm font-bold" data-id="element-514" data-mp="3srh55i6vfewi">
            <CheckIcon size={16} aria-hidden="true" data-id="element-515" data-mp="1vmekt666ouww" /> Chosen
          </span>}
      </span>
      {summary && <span className={selected ? 'text-cream' : 'text-ink/80'} data-id="element-516" data-mp="1qnv0tbb5ht76">{summary}</span>}
      {note && <span className={`mt-auto pt-2 text-sm ${selected ? 'text-cream' : 'text-ink/80'}`} data-id="element-517" data-mp="24mupuk2ksa3v">{note}</span>}
    </button>;
}